var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm: "6",
              },
            },
            [
              _c(
                "v-menu",
                {
                  ref: "showDateDialog",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.dateSelect,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  on: {
                    "update:returnValue": function ($event) {
                      _vm.dateSelect = $event
                    },
                    "update:return-value": function ($event) {
                      _vm.dateSelect = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (_ref) {
                        var on = _ref.on,
                          attrs = _ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    "prepend-icon": "mdi-calendar",
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.dateSelectDisplay,
                                    callback: function ($$v) {
                                      _vm.dateSelectDisplay = $$v
                                    },
                                    expression: "dateSelectDisplay",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.showDateDialog,
                    callback: function ($$v) {
                      _vm.showDateDialog = $$v
                    },
                    expression: "showDateDialog",
                  },
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.$refs.showDateDialog.save(_vm.dateSelectDisplay)
                        _vm.showDateDialog = false
                        _vm.getReportAgentCash()
                      },
                    },
                    model: {
                      value: _vm.dateSelect,
                      callback: function ($$v) {
                        _vm.dateSelect = $$v
                      },
                      expression: "dateSelect",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt-5",
        },
        [
          _c("v-simple-table", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        {
                          staticClass: "bg-dark",
                        },
                        [
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                              attrs: {
                                width: "30%",
                              },
                            },
                            [_vm._v("\n              วันที่\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                              attrs: {
                                width: "20%",
                              },
                            },
                            [_vm._v("\n              ยอดฝาก\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                              attrs: {
                                width: "20%",
                              },
                            },
                            [_vm._v("\n              ยอดถอน\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "bg-dark text-center text-light",
                              attrs: {
                                width: "30%",
                              },
                            },
                            [_vm._v("\n              เหลือ\n            ")]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.dataResult, function (item) {
                        return _c(
                          "tr",
                          {
                            key: item.id,
                          },
                          [
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.dateStart) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-success text-right",
                                attrs: {
                                  align: "center",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Number(item.amount_debit).toLocaleString(
                                        "en-US"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-warning text-right",
                                attrs: {
                                  align: "center",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Number(item.amount_credit).toLocaleString(
                                        "en-US"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                class:
                                  item.amount_total > 0
                                    ? "text-right text-success"
                                    : "text-right text-danger",
                                attrs: {
                                  align: "center",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Number(item.amount_total).toLocaleString(
                                        "en-US"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.preload
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500",
                "max-width": "100vw",
              },
              model: {
                value: _vm.preload,
                callback: function ($$v) {
                  _vm.preload = $$v
                },
                expression: "preload",
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-md-10 mx-lg-auto",
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "text-center",
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          size: 100,
                          width: 10,
                          indeterminate: "",
                          color: "primary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }